<svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
  <path d="M1 8.5H23M0.5 18V6C0.5 5 1 4.5 2 4.5H22C23 4.5 23.5 5 23.5 6V18C23.5 19 23 19.5 22 19.5H2C1 19.5 0.5 19 0.5 18Z" stroke="#000" stroke-width="1.5"/>
</svg>
